import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpLoginToken implements ICommand
{

	public Result : number = 0;
	public Token : string = "";
	public URL : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Result = ba.readUint32();
		this.Token = ba.readString();
		this.URL = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint32(this.Result);
		ba.writeString(this.Token);
		ba.writeString(this.URL);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpLoginToken();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Result(D)='+this.Result+' ';
		str += 'Token(S)='+this.Token+' ';
		str += 'URL(S)='+this.URL+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50036;
	}

	public getCmdName() : string
	{
		return 'SpLoginToken';
	}

}
